import { jsx as _jsx } from "react/jsx-runtime";
import ButtonGroup from '../buttonGroup';
import { cs, dimmedBorderColor } from '../utils';
/**
 * Organizes layout and display of multiple buttons. Based on ButtonGroup and should be used to toggle options.
 */
export const ButtonToggleGroup = (props) => {
    const { className, isDimmedBorder } = props;
    return (_jsx(ButtonGroup, { className: cs('vui-buttonToggleGroup', className), innerBorderColor: isDimmedBorder ? dimmedBorderColor : '', ...props }));
};
ButtonToggleGroup.displayName = 'ButtonToggleGroup';
export default ButtonToggleGroup;
